import {FC} from 'react'
import {TAX_FOLDER_SSO_LOGIN_URL, canUseTaxFolderSso} from '../core/taxFolderSso'

const TaxFolderSsoButton: FC = () => {
  if (!canUseTaxFolderSso(window.location.hostname)) {
    return null
  }

  return (
    <div className='auth-sso'>
      <a href={TAX_FOLDER_SSO_LOGIN_URL} className='auth-sso__button'>
        <i className='las la-landmark' aria-hidden='true' /> ورود با کارپوشه مالیاتی
      </a>
      <span className='auth-sso__hint'>درگاه سازمان امور مالیاتی</span>
    </div>
  )
}

export {TaxFolderSsoButton}
